import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { CheckCircle, ExternalLink } from 'lucide-react';
import './OnboardingRecrue.css';
import { setSelectedRole } from '../../../redux/actions/roleActions';

const WELCOME_URL = 'http://198.244.143.54:8888/welcome';

const normalizeAppPath = (path) => {
    if (!path || typeof path !== 'string') return '';
    const trimmed = path.trim();
    if (!trimmed) return '';
    return trimmed.startsWith('/') ? trimmed : `/${trimmed}`;
};

const getRolePath = (role) => {
    const roleName = `${role?.name || ''} ${role?.code || ''}`.toUpperCase();
    const compactRoleName = roleName.replace(/\s+/g, '');
    if (Number(role?.id) === 54 || compactRoleName.includes('RESPONSABLEONBOARDING')) return '/recrutement/onboarding/configuration';
    if (Number(role?.id) === 53 || compactRoleName.includes('NRONBOARDING')) return '/collaborateur/onboarding';
    return normalizeAppPath(role?.routePath || role?.modulePath || role?.module_path);
};

const OnboardingRecrue = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const currentUser = useSelector(state => state?.user?.currentUser || state.auth?.user);
    const selectedRole = useSelector(state => state.role?.selectedRole);
    const [isRoleMenuOpen, setIsRoleMenuOpen] = useState(false);
    const roleMenuRef = useRef(null);

    const userRoles = (currentUser?.roles || []).filter(
        role => role.moduleId === selectedRole?.moduleId
    );

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (roleMenuRef.current && !roleMenuRef.current.contains(event.target)) {
                setIsRoleMenuOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const handleRoleChange = (role) => {
        dispatch(setSelectedRole(role));
        const route = getRolePath(role);
        if (route) {
            navigate(route);
        }
        setIsRoleMenuOpen(false);
    };

    const handleWelcomeClick = () => {
        window.open(WELCOME_URL, '_blank', 'noopener,noreferrer');
    };

    return (
        <main className="onbup-page">
            <div className="onbup-role-menu" ref={roleMenuRef}>
                <button
                    type="button"
                    className="onbup-role-trigger"
                    onClick={() => setIsRoleMenuOpen(!isRoleMenuOpen)}
                >
                    <span>{selectedRole?.name || 'Changer de rôle'}</span>
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                        <path d="M6 9l6 6 6-6" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </button>

                {isRoleMenuOpen && userRoles.length > 0 && (
                    <div className="onbup-role-dropdown">
                        <div className="onbup-role-label">Changer de rôle</div>
                        {userRoles.map((role) => (
                            <button
                                type="button"
                                key={role.id}
                                className={`onbup-role-option${selectedRole?.id === role.id ? ' active' : ''}`}
                                onClick={() => handleRoleChange(role)}
                            >
                                <span>{role.name}</span>
                                {selectedRole?.id === role.id && <CheckCircle size={15} />}
                            </button>
                        ))}
                    </div>
                )}
            </div>

            <section className="onbup-card" aria-labelledby="onbup-title">
                <h1 id="onbup-title" className="onbup-title">
                    Plateforme d'Onboarding
                </h1>
                <p className="onbup-subtitle">
                    Accédez à votre espace d'intégration personnalisé
                </p>
                <button type="button" className="onbup-button" onClick={handleWelcomeClick}>
                    <ExternalLink size={22} strokeWidth={2.4} />
                    <span>Accéder à la plateforme</span>
                </button>
            </section>
        </main>
    );
};

export default OnboardingRecrue;
